import { createContext, useContext, useState, ReactNode } from 'react';

interface UserContextType {
  profileDetails: any;
  setProfileDetails: (data: any) => void;
  roleDetails:any, 
  setRoleDetails:(data: any) => void;
  companySetting:any, 
  setCompanySetting:(data: any) => void;

}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserContextProvider');
  }
  return context;
}

interface MyContextProviderProps {
  children: ReactNode;
}

export function UserContextProvider({ children }: MyContextProviderProps) {
  const [profileDetails, setProfileDetails] = useState(null); 
  const [roleDetails, setRoleDetails] = useState(null); 
  const [companySetting, setCompanySetting] = useState(null); 



  const contextValue: UserContextType = {
    profileDetails,
    setProfileDetails,
    roleDetails, 
    setRoleDetails,
    companySetting, 
    setCompanySetting
  };

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
}
